import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import { CreateWebCarousel, WebContentItem } from 'types/settings/webcontent'

// add web content
const addSlideToWeb = async (payload: CreateWebCarousel) => {
  const response = await axiosPost(payload, `v1/carousel-content`)
  return response.data
}

export const useAddSlideToWeb = () => {
  return useMutation(addSlideToWeb)
}

// get web content
const getWebContent = async () => {
  const response = await axiosGet(`v1/carousel-content`)
  return response.data
}

export const useGetWebContent = () => {
  const webContent = useQuery<WebContentItem[]>(
    ['web-content'],
    getWebContent,
    {
      enabled: false,
    },
  )
  return webContent
}

// delete web content
const deleteWebContent = async (carouselContentId: string) => {
  const response = await axiosDelete(`v1/carousel-content/${carouselContentId}`)
  return response.data
}

export const useDeleteWebContent = () => {
  return useMutation(deleteWebContent)
}

// update slide content
const updateSlideContent = async ({
  payload,
  slideId,
}: {
  payload: CreateWebCarousel
  slideId: string
}) => {
  const response = await axiosPatch(payload, `v1/carousel-content/${slideId}`)
  return response.data
}

export const useUpdateSlideContent = () => {
  return useMutation(updateSlideContent)
}

const reorderSlides = async (payload: {
  carousels: {
    carouselContentId: string
    order: number
  }[]
}) => {
  const response = await axiosPatch(payload, `v1/carousel-content/update-order`)
  return response.data
}

export const useReorderSlides = () => {
  const queryClient = useQueryClient()
  return useMutation(reorderSlides, {
    onSuccess: data => {
      queryClient.setQueryData(['web-content'], () => {
        return data
      })
    },
  })
}
